import React from "react";
import { IPhone } from "shared/types";
import { formatPhone } from "shared/utils";

import { FancyAnchorLink } from "shared/components";

interface PhoneProps {
  phone: IPhone;
}

export const Phone: React.FC<PhoneProps> = ({ phone }) => (
  <FancyAnchorLink href={`tel:${formatPhone(phone)}`} target="_blank" rel="noreferrer">
    {formatPhone(phone)}
  </FancyAnchorLink>
);
